"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputFormatter = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useMergedState_1 = tslib_1.__importDefault(require("rc-util/lib/hooks/useMergedState"));
var useEnhance_1 = tslib_1.__importDefault(require("../../useEnhance"));
var usePersistFn_1 = tslib_1.__importDefault(require("./usePersistFn"));
var toInputValueStr = function (inputValue) {
    return Array.isArray(inputValue)
        ? inputValue.join('')
        : inputValue === undefined || inputValue === null
            ? ''
            : String(inputValue);
};
var formatFloat = function (inputValue, preValue, type, options) {
    if (options === void 0) { options = { precision: 2 }; }
    var precision = options.precision, min = options.min, max = options.max;
    var value = toInputValueStr(inputValue);
    var preValueStr = toInputValueStr(preValue);
    var returnValue = value;
    if (value === '') {
        return value;
    }
    if (type === 'blur') {
        if (value.charAt(value.length - 1) === '.' || value === '-') {
            returnValue = value.slice(0, -1);
        }
        returnValue = returnValue.replace(/0*(\d+)/, '$1');
        if (min !== undefined && Number(returnValue) < min) {
            returnValue = "".concat(min);
        }
        if (max !== undefined && Number(returnValue) > max) {
            returnValue = "".concat(max);
        }
        if (precision > 0) {
            returnValue = parseFloat(returnValue).toFixed(precision);
        }
    }
    var rex = min < 0 ? /^-?\d*(\.\d*)?$/ : /^\d*(\.\d*)?$/;
    if (!rex.test(value)) {
        returnValue = preValueStr;
    }
    if (precision === 0) {
        returnValue = returnValue.replace(/\.$/, '');
    }
    else {
        returnValue = returnValue.replace(/\.(\d+)$/, function ($1) { return $1.slice(0, precision + 1); });
    }
    return returnValue;
};
var builtInFormatter = {
    float: formatFloat,
    number: formatFloat,
};
var useInputFormatter = function (options, props) {
    if (props === void 0) { props = {}; }
    var _a = options.formatter, formatter = _a === void 0 ? 'float' : _a, restOptions = tslib_1.__rest(options, ["formatter"]);
    var formatOptions = restOptions;
    var preValueRef = (0, react_1.useRef)(props.defaultValue || props.value);
    var acFormatter = typeof formatter === 'string' ? builtInFormatter[formatter] : formatter;
    var formatFn = (0, usePersistFn_1.default)(function (value, preValue, type) {
        return acFormatter(value, preValue, type, formatOptions);
    });
    if (!acFormatter) {
        console.warn('没有这个内置 formatter');
        return [props, props.value || props.defaultValue, function (_) { }];
    }
    var _b = tslib_1.__read((0, react_1.useState)(formatFn(props.value, preValueRef.current, 'init')), 2), innerValue = _b[0], setInnerValue = _b[1];
    var _c = tslib_1.__read((0, useMergedState_1.default)(formatFn(props.defaultValue, preValueRef.current, 'init'), {
        value: innerValue,
        onChange: setInnerValue,
    }), 1), mergedValue = _c[0];
    var changeHandler = (0, useEnhance_1.default)(function (e) {
        var _a;
        var newValue = formatFn(e.target.value, preValueRef.current, 'change');
        e.target.value = newValue;
        setInnerValue(newValue);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }, props.onChange);
    var blurHandler = (0, useEnhance_1.default)(function (e) {
        var _a, _b;
        var newValue = formatFn(e.target.value, preValueRef.current, 'blur');
        if (e.target.value !== newValue) {
            e.target.value = newValue;
            setInnerValue(newValue);
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }
        (_b = props.onBlur) === null || _b === void 0 ? void 0 : _b.call(props, e);
    }, props.onBlur);
    (0, react_1.useEffect)(function () {
        var newValue = formatFn(preValueRef.current, preValueRef.current, 'init');
        setInnerValue(newValue);
    }, [JSON.stringify(formatOptions)]);
    preValueRef.current = mergedValue;
    return [
        {
            value: mergedValue,
            defaultValue: mergedValue,
            onChange: changeHandler,
            onBlur: blurHandler,
        },
        innerValue,
        setInnerValue,
    ];
};
exports.useInputFormatter = useInputFormatter;
//# sourceMappingURL=useInputFormatter.js.map